import Image from "next/image";

import Button from "@/components/button/Button";
import Heading from "@/components/heading/heading";

import ctaImgMobile from "@/public/png/common/enquiry/cta-img-2-mobile.png";

import "@/sections/destination/thailand/enquiry-two.scss"
import { Link } from "react-scroll";

const Enquiry = () => {
    return (
        <div className="enquiry-two-block items-center px-4 grid grid-cols-1 sm:gap-4 md:grid-cols-8 lg:grid-cols-12">
            <div className="lg:px-8 col-span-1 md:col-span-4">
                <div className="enquiry-two-info py-6 sm:py-14 gap-2 flex flex-col items-start">
                    <Heading as="h2" className="text-white">
                    Ready to experience the enchantment of Thailand?
                    </Heading>
                    <p className="text-white">
                    Enquire now for personalized travel plans and make your Thai dreams a 
reality!
                    </p>
                    <Link to="hero">
                        <Button className="flex-center" variant="green">
                            <span>Send Enquiry</span>
                        </Button>
                    </Link>
                </div>
            </div>
            <div className="enquiry-two-picture col-span-1 md:col-span-4 my-28">
                {/* <Image loading="lazy"
                    src={ctaImgMobile}
                    alt="circle pattern"
                    className="cta-image"
                    
                /> */}
            </div>
        </div>
    );
};

export default Enquiry;
